"use strict";
var $ = require("../internals/export");
$({ target: "Number", stat: true }, {
  isNaN: function isNaN(number) {
    return number !== number;
  }
});
